import {inject, Injectable} from '@angular/core';
import {CanActivate, Router} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {MatDialog} from '@angular/material/dialog';
import {ExpiredTokenDialog} from './expired-token-dialog/expired-token-dialog.component';
import {UserService} from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  private _dialog = inject(MatDialog);
  private _user = inject(UserService);
  private _auth = inject(AuthService);

  canActivate(): boolean {
    if (this._auth.getToken()) {
      return true;
    } else {
      this._dialog.open(ExpiredTokenDialog);
      this._user.clearUser();
      this._auth.logout();
      return false;
    }
  }
}
